import { render, staticRenderFns } from "./tabBasic.vue?vue&type=template&id=f705ed00&"
import script from "./tabBasic.vue?vue&type=script&lang=js&"
export * from "./tabBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f705ed00')) {
      api.createRecord('f705ed00', component.options)
    } else {
      api.reload('f705ed00', component.options)
    }
    module.hot.accept("./tabBasic.vue?vue&type=template&id=f705ed00&", function () {
      api.rerender('f705ed00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/cabinManagement/tabBasic.vue"
export default component.exports